/* eslint-disable @typescript-eslint/no-explicit-any */
import { getSchoolContext } from '@/hooks/useAuthentication';
import { GetCurrentSchoolYearUseCase } from '@/pages/mission/use-cases/get-current-school-year';

export interface SearchFilters {
  searchTerm?: string;
  keyStages?: string[];
  traits?: string[];
  contentTypes?: string[];
}

export const buildMissionsQueryVariables = (filters: SearchFilters, schoolDocumentId?: string) => ({
  roleModel: filters.searchTerm,
  keyStages: filters.keyStages,
  traits: filters.traits,
  pagination: { start: 0, limit: 2 },
  schoolYear: GetCurrentSchoolYearUseCase.execute(),
  schoolDocumentId,
});

export const buildProgrammesQueryVariables = (filters: SearchFilters) => {
  const queryFilters: Record<string, any> = {};

  if (filters.keyStages && filters.keyStages.length > 0) {
    queryFilters.keyStage = { keyStage: { in: filters.keyStages } };
  }

  if (filters.traits && filters.traits.length > 0) {
    queryFilters.trait = { trait: { in: filters.traits } };
  }

  return {
    name: filters.searchTerm,
    missionsFilters: queryFilters,
    schoolDocumentId: getSchoolContext()?.documentId,
    pagination: { pageSize: 2, page: 1 },
  };
};

export const buildCoursesQueryVariables = (filters: SearchFilters) => {
  const queryFilters: Record<string, any> = {};

  if (filters.searchTerm) {
    queryFilters.or = [
      { title: { containsi: filters.searchTerm } },
      { description: { containsi: filters.searchTerm } },
    ];
  }

  queryFilters.publishedAt = { notNull: true };

  return {
    filters: queryFilters,
    pagination: { pageSize: 2, page: 1 },
  };
};

export const buildResourcesQueryVariables = (filters: SearchFilters) => {
  const queryFilters: Record<string, any> = {};

  if (filters.contentTypes && filters.contentTypes.length > 0) {
    queryFilters.resourceType = { type: { in: filters.contentTypes } };
  }

  if (filters.traits && filters.traits.length > 0) {
    queryFilters.subTraits = { subTrait: { in: filters.traits } };
  }

  queryFilters.publishedAt = { notNull: true };
  queryFilters.title = { containsi: filters.searchTerm };

  return {
    filters: queryFilters,
    limit: 2,
    page: 1,
  };
};
